import type { ReactNode } from "react";

import { cn } from "../../../lib/cn";
import { nameInitials } from "../../../utils/nameInitials";
import { TenantAvatar } from "../../TenantAvatar";
import { Label } from "../../typography/Label";
import { useMessage } from "./Context";

type MessageRowProps = {
    children: ReactNode;
};

export function MessageRow({ children }: MessageRowProps) {
    const { sender } = useMessage();

    return (
        <div
            className={cn(
                "flex max-w-full flex-row items-end gap-8",
                sender === "member" ? "flex-row-reverse" : undefined,
            )}
        >
            <MessageAvatar />
            <div className="min-w-0 max-w-full">{children}</div>
        </div>
    );
}

function MessageAvatar() {
    const { sender, showSenderRow, avatarUrl, senderName, useServiceEmblem } =
        useMessage();

    if (sender !== "agent") {
        return null;
    }

    if (!showSenderRow) {
        return <div className="w-24 min-w-24 shrink-0" />;
    }

    if (avatarUrl) {
        return (
            <img
                src={avatarUrl}
                alt={senderName ?? ""}
                className="size-24 min-h-24 min-w-24 shrink-0 rounded-full object-cover"
            />
        );
    }

    if (useServiceEmblem) {
        return <TenantAvatar size="small" className="shrink-0" />;
    }

    return (
        <div className="flex size-24 min-h-24 min-w-24 shrink-0 items-center justify-center rounded-full bg-component-avatar-agent">
            <Label
                size="xsmall"
                weight="medium-bold"
                className="text-component-avatar-text"
            >
                {senderName ? nameInitials(senderName) : ""}
            </Label>
        </div>
    );
}
